<template>
    <div class="page-wrapper">
        <AppHeader title="Mobile Payment Providers" />
        <div class="container-fluid">
            <Void :open="isVoidOpen" @getVoidPermission="setVoidPermission($event)" @close="isVoidOpen = !isVoidOpen" />
            <div class="container-fluid left">

                <div class="row topnav" style="padding-left: 15px;">
                    <!-- <div class="col-sm-1">
                        <div class="dropdown" style="position:fixed;left:0;top:0;padding:0;margin-top:0;margin-bottom:0">
                            <MainMenu />
                        </div>
                    </div> -->
                    <div class="col-sm-11">
                    <div v-show="showError" style="text-align:center">
                        <label class="h3" style="color:maroon"> {{ this.mainErrorMsg }} </label>
                    </div>
                </div>
            </div>
            <div v-if="showAddPromotion" style="width:100%; display: flex; justify-content: center;">
                <div class="card shadow-lg" style="background-color: var(--form-color); padding: 30px; border-radius: 15px; width: 100%; max-width: 600px; color: var(--theme-text-main);">
                    <div class="form-group mb-3">
                        <label title="name" style="font-size:1.2em; display: block; margin-bottom: 5px;">Mobile Payment Provider Name</label>
                        <input type="text" v-model="name" class="form-control input-lg" style="font-size:1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);">
                    </div>
                    
                    <div style="text-align:right; margin-top:20px; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 20px;">
                        <button class="btn btn-danger btn-lg" style="font-size:1.2em; margin-right: 10px;" @click="cancelSavePromotion">Cancel</button>
                        <button class="btn btn-success btn-lg" v-if="mobilePaymentProviderId === -1" style="font-size:1.2em;"
                            @click="createMobilePaymentProvider">Save</button>
                        <button class="btn btn-success btn-lg" v-if="mobilePaymentProviderId !== -1" style="font-size:1.2em;"
                            @click="updateMobilePaymentProvider">Update</button>
                    </div>

                </div>
            </div>
            <div v-if="toggle">
                
                <div class="touch-search-header">
                    <div class="touch-search-area">
                        <div class="input-group touch-search-group">
                            <span class="input-group-addon">
                                <i class="glyphicon glyphicon-search"></i>
                            </span>
                            <input
                                type="text"
                                v-model="searchMobilePaymentProvider"
                                class="form-control input-lg"
                                placeholder="Search providers"
                                @keyup.enter="applyMobilePaymentProviderSearch()"
                            >
                            <span class="input-group-btn">
                                <button class="btn btn-success btn-lg" @click="applyMobilePaymentProviderSearch()">
                                    Search
                                </button>
                            </span>
                        </div>
                    </div>
                    <div class="touch-search-actions">
                        <button
                            class="btn btn-success btn-lg"
                            v-if="hasPermission(49)"
                            @click="handleAddMobilePaymentProvider"
                        >
                            New Provider
                        </button>
                    </div>
                </div>
                <br>
                <div v-if="toggle" class="row table-wrap" style="color: #fff; ">
                    <table class="table" style="color: #fff;">
                        <thead>
                            <tr>
                                <th style="font-size:1.1em">Provider Name</th>
                                <th style="font-size:1em"> </th>
                                <th style="font-size:1em"> </th>

                           
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="mobilePaymentProvider in filteredMobilePaymentProviders" :key="mobilePaymentProvider.id">
                                <td style="font-size:1.2em">{{ mobilePaymentProvider.name }}</td>
                                <td><button v-if="hasPermission(50)" class="btn btn-success" style="font-size:1em"
                                        @click="editMobilePaymentProvider(mobilePaymentProvider)">Edit</button></td>
                                <td><button v-if="hasPermission(51)" class="btn btn-danger" style="font-size:1em"
                                        @click="deleteMobilePaymentProvider(mobilePaymentProvider)">Delete</button></td>
    
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices"
import MainMenu from "@/components/MainMenu";
import AppHeader from "@/components/AppHeader";
import Datepicker from 'vuejs3-datepicker';
import 'vue-date-pick/dist/vueDatePick.css';
import Void from "@/components/Void";
export default {
    computed: {
        filteredMobilePaymentProviders() {
            let list = this.allMobilePaymentProviders || [];
            const search = (this.searchMobilePaymentProvider || "").toLowerCase();

            if (search) {
                list = list.filter((p) => {
                    const name = (p.name || "").toLowerCase();
                    const id = (p.id || "").toString().toLowerCase();
                    return name.includes(search) || id.includes(search);
                });
            }

            return list;
        },
    },
    mixins: [commonServices],
    mounted() {
        this.getAllMobilePaymentProviders();
        if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
        } else {
            this.$router.push({ name: 'login' });
        }
        this.language = 'ar';
        this.logoImage = '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
    },
    components: { MainMenu, Datepicker, Void, AppHeader },
    data: function () {
        return {
            modulePermissions: [],
            state: { start_date: new Date(2016, 9, 16) },
            stateEnd: { end_date: new Date(2016, 9, 16) },
            showAddPromotion: false,
            showDuplicatePromotion: false,
            showPermissions: false,
            promotions: [],
            allMobilePaymentProviders: [],
            searchMobilePaymentProvider: '',
            mobilePaymentProviderJson: {},
            promotionJson: {},
            promotionInfos: {},
            mobilePaymentProviderId: -1,
            promoition_name: '',
            start_date: '',
            end_date: '',
            minimum_total: '',
            percentage: '',
            name: '',
            authorizedToChangePrice: 'N',
            isVoidOpen: false,
            reports_ok: false,
            showError: false,
            logoImage: '',
            mainErrorMsg: '',
            logoUrl: '',
            jsonData: {},
            language: 'en',
            languageName: '',
            toggle: true,
            showInvoices: false,
            showPayments: false,
            addresses: [],
            selectedcustomers: [],
            customer_invoices: [],
            customer_payments: [],
            customersJson: {},
            name: '',
            gender: '',
            email: '',
            phone: '',
            totalpoints: '',
            dis_percentage: '',
            status: '',
            creditstatus: '',
            date_added: '',
            aaddressid: 0,
            addressLine1: '',
            addressLine2: '',
            addressArea: '',
            addressCity: '',
            isDefault: false,
            customerAddresses: [],
            showAddress: false,
            findcustomer: '',
            findcustomername: '',
            customeraddress: {},
            mobilePaymentProviderPerms: [],
        }
    },
    methods: {
        applyMobilePaymentProviderSearch() {
            this.searchMobilePaymentProvider = (this.searchMobilePaymentProvider || '').trim();
        },
        async setVoidPermission(authorizedToChangePrice) {
            if (authorizedToChangePrice === 'Y') {
                this.mobilePaymentProviderJson.appId = localStorage.appId;
                this.mobilePaymentProviderJson.id = this.mobilePaymentProviderId

                try {
                    let dataURL = this.apiURL + 'MobilePaymentProviders/deleteMobilePaymentProvider';
                    let response = await axios.post(dataURL, this.mobilePaymentProviderJson);
                    if (response.data.status === 'success') {
                        this.showSuccess("MobilePaymentProvider Deleted Successfully!");
                        this.getAllMobilePaymentProviders();
                        this.cancelSavePromotion();
                    } else {
                        this.showAlert("Error Happened Please Check Entered Data!");
                    }

                }
                catch (error) {
                    console.log(error);
                }
            } else {
                // Error message mo permission
            }
            this.authorizedToChangePrice = 'N'
        },
        editMobilePaymentProvider(mobilePaymentProvider) {
            this.name = mobilePaymentProvider.name;
            this.mobilePaymentProviderId = mobilePaymentProvider.id;
            this.toggle = false;
            this.showAddPromotion = true;
        },
        duplicateMobilePaymentProvider(mobilePaymentProvider) {
            this.name = mobilePaymentProvider.name;
            this.mobilePaymentProviderId = mobilePaymentProvider.id;
            this.toggle = false;
            this.showAddPromotion = false;
            this.showDuplicatePromotion = true;
        },
        deleteMobilePaymentProvider: function (mobilePaymentProvider) {
            this.isVoidOpen = true;
            this.mobilePaymentProviderId = mobilePaymentProvider.id;
        },
        createMobilePaymentProvider: async function () {
            if(this.name == ''){
                this.showAlert("Please Fill All fields!");
                return;
            }
            this.mobilePaymentProviderJson.appId = localStorage.appId;
            if(this.name.indexOf('Mobile') > -1){
                this.name.toLowerCase().replace('mobile', '');
            }
            this.mobilePaymentProviderJson.name = this.name;
            try {
                let dataURL = this.apiURL + 'MobilePaymentProviders/createMobilePaymentProvider';
                let response = await axios.post(dataURL, this.mobilePaymentProviderJson);
                if (response.data.status === 'success') {
                    this.showSuccess("MobilePaymentProvider Added Successfully!");
                    this.getAllMobilePaymentProviders();
                    this.handleAddMobilePaymentProvider();
                    this.cancelSavePromotion();
                } else {
                    this.showAlert("Error Happened Please Check Entered Data!");
                }

            }
            catch (error) {
                console.log(error);
            }
        },
        cancelSavePromotion() {
            this.toggle = true;
            this.showAddPromotion = false;
            this.showPermissions = false;
            this.showDuplicatePromotion = false;
        },

        updateMobilePaymentProvider: async function () {
            if(this.name == ''){
                this.showAlert("Please Fill All fields!");
                return;
            }
            this.mobilePaymentProviderJson.appId = localStorage.appId;
            this.mobilePaymentProviderJson.id = this.mobilePaymentProviderId
            this.mobilePaymentProviderJson.name = this.name;

            try {
                let dataURL = this.apiURL + 'MobilePaymentProviders/updateMobilePaymentProvider';
                let response = await axios.post(dataURL, this.mobilePaymentProviderJson);
                if (response.data.status === 'success') {
                    this.showSuccess("MobilePaymentProvider Updated Successfully!");
                    this.getAllMobilePaymentProviders();
                    this.cancelSavePromotion();
                } else {
                    this.showAlert("Error Happened Please Check Entered Data!");
                }

            }
            catch (error) {
                console.log(error);
            }
        },
        

        handleAddMobilePaymentProvider: async function () {
            this.showAddPromotion = true;
            this.mobilePaymentProviderId = - 1;
            this.name = '';
            this.showError = false;
            this.mainErrorMsg = "";
            this.showAddCustomer = true;
            this.toggle = false;
        },
        getAllMobilePaymentProviders: async function () {
            this.mobilePaymentProviderJson.appId = localStorage.appId;
            try {
                let dataURL = this.apiURL + 'MobilePaymentProviders/getAllMobilePaymentProviders';
                let response = await axios.post(dataURL, this.mobilePaymentProviderJson);
                if (response.data.status === 'success') {
                    this.allMobilePaymentProviders = response.data.results;
                }
            }
            catch (error) {
                console.log(error);
            }
            return this.allMobilePaymentProviders;
        }
    }
}
</script>
<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    margin-top: 20px;
}

.glyphicon.glyphicon-ok {
    font-size: 30px;
}

.button {
    font: bold 15px Arial;
    text-decoration: none;
    background-color: #EEEEEE;
    color: #333333;
    /* padding: 2px 6px 2px 6px;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #333333;
    border-bottom: 1px solid #333333;
    border-left: 1px solid #CCCCCC; */
}

.grid-container-element {
    display: grid;
    grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
    grid-gap: 10px;
    border: 1px solid whitesmoke;
    border-left: 0px;
    border-right: 0px;
    border-top: 0px;
    width: 100%;
}

.grid-child-element_ {
    margin: 10px;
    border: 1px solid red;
}

.grid-child-element {
    margin: 2px;
    border-left: 0px;
    border-right: 0px;
    border-top: 0px;
    padding: 0 px;

}

.check-label {
    color: #fff;
    font-size: 1.5rem;
    margin-left: 1rem;
    margin: 1rem 0;
}
</style>
